// axios
import axios from 'axios'

// const baseURL = 'http://hrm.fireexit.co.th:9001'
// const baseURL = 'http://192.168.2.38:9001'
const baseURL = 'http://dustnorthernthailand.online:9191'
//const baseURL = 'http://dustnorthernthailand.org:9191'
export default axios.create({
  baseURL
  // You can add your headers here
})
